export default (payload) => ({
  type: 'UPDATE_LEADS_STATE',
  payload,
});
